import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.sass']
})
export class ServiceComponent implements OnInit {

  constructor(private dataService: DataService) { }

  get groupedItems () {
    var sorted = this.dataService.getPrices().reduce((map, curr) => {
      
      var arr = map[curr.type]
      if (!arr) {
        arr = []
      }
      arr.push(curr)
      map[curr.type] = arr
      return map

    }, {})

    var grouped = [];
    Object.keys(sorted).forEach(key => {
      grouped.push({
        'label': key,
        'items': sorted[key],
      });
    });

    return grouped;
  }

  ngOnInit() {
  }

}
